import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface AuthCardProps {
  children: ReactNode;
  className?: string;
}

export function AuthCard({ children, className }: AuthCardProps) {
  return <div className={cn("w-full", className)}>{children}</div>;
}

interface AuthCardHeaderProps {
  title: string;
  subtitle?: ReactNode;
  logo?: ReactNode;
  className?: string;
}

export function AuthCardHeader({ title, subtitle, logo, className }: AuthCardHeaderProps) {
  return (
    <div className={cn("mb-[14px]", className)}>
      {logo && <div className="mb-4">{logo}</div>}
      <h1
        className="text-[30px] sm:text-[32px] lg:text-[34px] font-bold leading-tight tracking-[-0.02em]"
        style={{ color: '#0B1220' }}
      >
        {title}
      </h1>
      {subtitle && (
        <div
          className="mt-[10px] text-[14px] sm:text-[15px] leading-relaxed"
          style={{ color: '#5B667A', opacity: 0.85 }}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
}

interface AuthCardFooterProps {
  children: ReactNode;
}

export function AuthCardFooter({ children }: AuthCardFooterProps) {
  return <div className="mt-[12px] text-center text-sm">{children}</div>;
}
